import React from 'react';
import { Box, FormControl, MenuItem, Select, Switch, FormControlLabel, useTheme } from '@mui/material';

interface StoriesHeaderControlsProps {
    showFuture: boolean;
    setShowFuture: (show: boolean) => void;
    sortDirection: 'ASC' | 'DESC';
    setSortDirection: (dir: 'ASC' | 'DESC') => void;
    tourHasStarted: boolean;
    lastStayReached: boolean;
}

export default function StoriesHeaderControls({
                                                  showFuture,
                                                  setShowFuture,
                                                  sortDirection,
                                                  setSortDirection,
                                                  tourHasStarted,
                                                  lastStayReached,
                                              }: StoriesHeaderControlsProps) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
                flexWrap: 'wrap',
                rowGap: 1,
                columnGap: 2,
                pb: 1,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                {!lastStayReached && tourHasStarted && (
                    <FormControlLabel
                        control={
                            <Switch
                                size="small"
                                checked={showFuture}
                                onChange={(e) => setShowFuture(e.target.checked)}
                            />
                        }
                        label="Zukünftige Aufenthalte anzeigen"
                    />
                )}
            </Box>

            <Box sx={{ ml: 'auto' }}>
                <FormControl size="small" sx={{ minWidth: 160 }}>
                    <Select
                        value={sortDirection}
                        onChange={(e) => setSortDirection(e.target.value as 'ASC' | 'DESC')}
                        sx={{
                            '.MuiSelect-select.MuiSelect-outlined': {
                                py: '9px',
                            },
                            '.MuiOutlinedInput-notchedOutline': {
                                borderColor: theme.palette.divider,
                            },
                        }}
                    >
                        <MenuItem value="DESC">Neueste</MenuItem>
                        <MenuItem value="ASC">Älteste</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Box>
    );
};